export type InvoiceReminderLevelSource = {
  invoice_id: string;
  reminder_number: number;
  status: string;
};

/**
 * Latest successfully sent rykker level for one invoice.
 * Uses invoice_reminders.reminder_number (the same sequence email history
 * copies from). Failed/skipped rows do not count. Overdue is ignored.
 */
export function latestSentReminderNumber(
  rows: ReadonlyArray<Pick<InvoiceReminderLevelSource, 'reminder_number' | 'status'>>,
): number | null {
  let latest: number | null = null;
  for (const row of rows) {
    if (row.status !== 'sent') continue;
    if (!Number.isInteger(row.reminder_number) || row.reminder_number < 1) continue;
    if (latest === null || row.reminder_number > latest) {
      latest = row.reminder_number;
    }
  }
  return latest;
}

export function reminderLevelsByInvoiceId(
  rows: ReadonlyArray<InvoiceReminderLevelSource>,
): Record<string, number> {
  const grouped = new Map<string, InvoiceReminderLevelSource[]>();
  for (const row of rows) {
    const list = grouped.get(row.invoice_id) ?? [];
    list.push(row);
    grouped.set(row.invoice_id, list);
  }

  const result: Record<string, number> = {};
  for (const [invoiceId, list] of grouped) {
    const level = latestSentReminderNumber(list);
    if (level !== null) result[invoiceId] = level;
  }
  return result;
}
